<template>
  <div>
    <div class="row">
      <div class="col-12 col-lg-12 p-0">
        <NotiPos />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12">
        <b-form-group id="input-group-1" label-for="input-search-couier">
          <b-input-group>
            <b-form-input
              id="input-search-couier"
              type="text"
              v-model="searchCourier"
              placeholder="ค้นหาขนส่ง"
              class="mt-2"
            >
              <b-input-group-append>
                <div class="d-flex align-items-center justify-content-center">
                  <i class="fas fa-search text-muted"></i>
                </div>
              </b-input-group-append>
            </b-form-input>
          </b-input-group>
        </b-form-group>
      </div>
    </div>
    <b-card-text class="p-0 scroll-bar-pop card-tab">
      <div class="row pr-3 py-2">
        <div class="col-4 col-lg-4 col-xl-4">
          <h4
            class="cursor-pointer d-flex align-items-center text-color-draft"
            v-if="!checkThemeQuick()"
            @click="emitModal('draftStorage')"
          >
            <span>
              <img :src="iconDraft.url" alt="" />
            </span>
            <span class="ml-1">
              {{ draftLength ? `ฉบับร่าง (${countDraft()})` : "ฉบับร่าง (0)" }}
            </span>
          </h4>
        </div>
        <div class="col-8 col-lg-8 col-xl-8">
          <div class="row d-flex justify-content-end pr-2">
            <b-button
              id="resetSorting"
              variant="warning"
              size="sm"
              :disabled="idOrder ? true : false"
              @click="resetSoring"
            >
              รีเซ็ตการจัดเรียง
            </b-button>
            <b-button
              id="checkPrice"
              :class="showCart !== 'non-slide' ? 'mr-4' : ''"
              variant="primary"
              size="sm"
              :disabled="idOrder ? true : false"
              @click="changeStepPosPage(getStepPage.STEP_PAGE_CHECKPRICE)"
            >
              <i class="fas fa-database"></i>
              เปรียบเทียบราคา
            </b-button>
          </div>
        </div>
      </div>
      <!-- COD CARD -->
      <draggable
        v-model="couriersCopy"
        :options="dragOptions"
        @end="onDragEnd"
        class="row pr-3"
      >
        <div
          v-for="courier in courierFilter"
          :key="courier.id"
          class="col-12 col-lg-6 col-xl-3 mb-3 pr-2"
        >
          <!-- Render COD -->
          <CardPos
            v-if="courier.id === 'cod'"
            :courier="{
              title: 'COD เก็บเงินปลายทาง',
              name: 'COD',
              icon: 'cod_by_shippop.jpg',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.courier || lockCardCourier.cod,
            }"
            @click.native="$emit('openModal', 'COD', '')"
          />

          <!-- Render Dropoff -->
          <CardPos
            v-else-if="courier.id === 'dropoff-shippop'"
            :courier="{
              title: 'DROP OFF (ลทบ / EMS)',
              name: 'SHIPPOP DROP OFF',
              icon: 'shippop-logo',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffShippop,
            }"
            @click.native="$emit('openModal', DROPOFF_SP, false)"
          />
          <CardPos
            v-else-if="courier.id === 'dropoff-vrich'"
            :courier="{
              title: 'DROP OFF (V RICH)',
              name: 'V RICH DROP OFF',
              icon: 'vrich-logo.png',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffVrich,
            }"
            @click.native="
              $emit('courierModalTime', courierDropoffVRich, ''),
                (dropoffVRich.show = true)
            "
          />
          <CardPos
            v-else-if="courier.id === 'dropoff-panpan'"
            :courier="{
              title: 'DROP OFF (PANPANWORLD)',
              name: 'PANPAN WORLD DROP OFF',
              icon: 'panpanworld-logo.png',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffPanPan,
            }"
            @click.native="
              $emit('courierModalTime', dropoffPanPan.courier, ''),
                (dropoffPanPan.show = true)
            "
          />
          <CardPos
            v-else-if="courier.id === 'dropoff-easyship'"
            :courier="{
              title: 'DROP OFF (EASYSHIP)',
              name: 'EASYSHIP DROP OFF',
              icon: 'easyship-logo.png',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffEasyship,
            }"
            @click.native="
              $emit('courierModalTime', courierDropoffEasyShip, ''),
                (dropoffEasyShip.show = true),
                (dropoffEasyShip.notCloseModal = true)
            "
          />
          <CardPos
            v-else-if="courier.id === 'dropoff-kerry'"
            :courier="{
              title: 'KEX Drop off',
              name: 'KEX Drop off',
              icon: 'kerry-dropoff-logo.png',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffKerry,
            }"
            @click.native="$emit('openModal', KERRY_DROPOFF, false)"
          />
          <CardPos
            v-else-if="courier.id === 'dropoff-lazada'"
            :courier="{
              title: 'Lazada Drop off',
              name: 'Lazada Drop off',
              icon: 'LZDS.png',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffLazada,
            }"
            @click.native="$emit('openModal', LAZADA_DROPOFF, false)"
          />
          <CardPos
            v-else-if="courier.id === 'dropoff-orange'"
            :courier="{
              title: 'Orange Drop off',
              name: 'Orange Drop off',
              icon: 'ORNG.png',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffKerry,
            }"
            @click.native="$emit('openModal', ORANGE_DROPOFF, false)"
          />
          <CardPos
            v-else-if="courier.id === 'dropoff-quick'"
            :courier="{
              title: 'DROP OFF (QUICK EXPRESS)',
              name: 'QUICK EXPRESS DROP OFF',
              icon: 'quick-logo.png',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffQuick,
            }"
            @click.native="
              $emit('courierModalTime', courierDropoffQuick, ''),
                (dropoffQuick.show = true)
            "
          />
          <CardPos
            v-else-if="courier.id === 'line-booking'"
            :courier="{
              title: 'LINE Booking',
              name: 'LINE Booking',
              icon: 'LINE_logo.png',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffLine,
            }"
            @click.native="$emit('openModal', 'LINE_BOOKING', false)"
          />
          <CardPos
            v-else-if="courier.id === 'dropoff-flash'"
            :courier="{
              title: 'Flash Drop off',
              name: 'Flash Drop off',
              icon: 'FLE.jpg',
            }"
            :starShow="false"
            :class="{
              disabled: idOrder,
              lockcourier: lockCardCourier.dropoffFlash,
            }"
            @click.native="$emit('openModal', FLASH_DROPOFF, false)"
          />

          <!-- Render Normal Couriers -->
          <CardPos
            v-else
            :courier="courier"
            :prebarcode="
              courier.shippop === 1 && courier.prebarcode === 1
                ? 'prebarcode'
                : ''
            "
            @returnEmit="emitCourierModalTime"
            :class="{
              disabled: idOrder,
              lockcourier:
                courier.shippop === 1 && courier.prebarcode === 1
                  ? lockCardCourier.prebarcode
                  : courier.shippop === 0
                  ? lockCardCourier.gen
                  : lockCardCourier.courier,
            }"
            :starShow="true"
          />
        </div>
      </draggable>
    </b-card-text>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CardPos from "@/components/CardPos";
import NotiPos from "@/components/custom/pos/NotiPos";
import { getStepPage } from "@/plugins/posHelper.js";
import popStorage from "@/constants/LocalStorageManagement";

export default {
  props: {
    showCart: String,
    cart: Array,
    draftStorage: [Object, Array],
    idOrder: [String, Number],
    posPage: Object,
    tabCourier: Object,
    couriers: Array,
    searchCourier: String,
    permission: Object,
    dropoffVRich: Object,
    dropoffPanPan: Object,
    dropoffEasyShip: Object,
    dropoffQuick: Object,
    cod: [String, Number],
    lockCardCourier: Object,
    DROPOFF_SP: String,
    LAZADA_DROPOFF: String,
    KERRY_DROPOFF: String,
    ORANGE_DROPOFF: String,
    FLASH_DROPOFF: String,
    showCourier: Function,
    courierDropoffVRich: [Object, Array],
    courierDropoffEasyShip: [Object, Array],
    courierDropoffQuick: [Object, Array],
    shopId: [Number, String],
  },
  data() {
    return {
      getStepPage: getStepPage,
      favCourierAll: Array,
      iconDraft: {
        url: require("../../../assets/icon/Drafts.svg"),
      },
      couriersCopy: [],
    };
  },
  components: {
    CardPos,
    NotiPos,
    draggable,
  },
  methods: {
    checkThemeQuick() {
      return this.$THEME.name == "quickexpress";
    },
    emitModal(key) {
      return this.$emit("openModalDraft", key);
    },
    countDraft() {
      return this.draftStorage ? Object.keys(this.draftStorage).length : 0;
    },
    draftLength() {
      return this.draftStorage
        ? Object.keys(this.draftStorage).length > 0
        : false;
    },
    async getfavCourier() {
      const header = {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
      };
      await this.$http
        .get(this.$API_URL + "/favCourier", header)
        .then((res) => {
          this.favCourierAll = res.data.data;
        });
    },
    changeStepPosPage(step) {
      if (getStepPage.STEP_PAGE_CHECKPRICE === step) {
        this.$emit("checkPriceFrom", "DOMESTIC");
      }
      this.posPage.step = step;
    },
    async emitCourierModalTime(e) {
      if (e.clickON && e.event.target.id === "star") {
        e.event.stopPropagation();
        const header = {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        };
        if (e.deleteON === true) {
          await this.getfavCourier();
          const idReq = this.favCourierAll.item.filter(
            (val) =>
              val.shop_id === this.shopId &&
              val.courier_id === parseInt(e.courier.id)
          );
          if (idReq.length) {
            this.$http
              .delete(this.$API_URL + `/favCourier/${idReq[0].id}`, header)
              .then((res) => {
                if (res.status === false) {
                  // eslint-disable-next-line
                  console.error("error", res.error);
                }
              })
              .finally(() => {
                return this.$emit("reverseCourier");
              });
          } else {
            // eslint-disable-next-line
            console.error("Could not found ID delete");
          }
        } else {
          const responeData = {
            courier_id: e.courier.id,
          };
          this.$http.post(this.$API_URL + "/favCourier", responeData, header);
          return this.$emit("reverseCourier");
          // window.location.reload()
        }
      } else {
        this.$emit("courierModalTime", e.courier, e.prebarcode);
      }
    },
    onDragEnd() {
      const payload = this.couriersCopy.reduce((acc, cur, index) => {
        acc[index] = {
          id: cur.id,
          name: cur.name,
        };

        return acc;
      }, {});

      popStorage.sortedCourier().set(payload);
    },
    resetSoring() {
      popStorage.sortedCourier().remove();
      this.$emit("reverseCourier");
    },
  },
  computed: {
    courierFilter() {
      return this.couriersCopy.filter((courier) => {
        if (courier.id === "cod") {
          return this.cod;
        }

        if (courier.id === "dropoff-shippop") {
          return this.permission.dropoffShippop;
        }

        if (courier.id === "dropoff-vrich") {
          return this.permission.dropoffVRich;
        }

        if (courier.id === "dropoff-panpan") {
          return this.permission.dropoffPanPan;
        }

        if (courier.id === "dropoff-easyship") {
          return this.permission.dropoffEasyShip;
        }

        if (courier.id === "dropoff-kerry") {
          return this.permission.kerryDropoff;
        }

        if (courier.id === "dropoff-lazada") {
          return this.permission.lazadaDropoff;
        }

        if (courier.id === "dropoff-orange") {
          return this.permission.orangeDropoff;
        }

        if (courier.id === "dropoff-quick") {
          return this.permission.dropoffQuick;
        }

        if (courier.id === "line-booking") {
          return this.permission.lineBooking;
        }

        if (courier.id === "dropoff-flash") {
          return this.permission.flashDropoff;
        }

        if (!isNaN(courier.id)) {
          const effective = new Date(courier.effective_date) < new Date();
          const expired =
            !courier.expired_date ||
            new Date(courier.expired_date).getTime() > Date.now();

          return (
            courier.title
              .toLowerCase()
              .includes(this.searchCourier.toLowerCase()) &&
            (!courier.effective_date || effective) &&
            expired &&
            this.showCourier(courier)
          );
        }

        return false;
      });
    },
    dragOptions() {
      return {
        animation: 400,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        // On touch devices Sortable starts a drag on the first pointermove of a tap and
        // swallows the click, so courier cards can't be tapped on mobile/tablet.
        // Require a long-press to drag on touch only; mouse dragging is unchanged.
        delay: 200,
        delayOnTouchOnly: true,
        touchStartThreshold: 5,
      };
    },
  },
  watch: {
    couriers: {
      immediate: true,
      handler(newVal) {
        const ls = popStorage.sortedCourier().get().sorted_courier;
        const d = [];

        if (this.cod) {
          d.push({
            id: "cod",
            name: "COD",
          });
        }
        if (this.permission.dropoffShippop) {
          d.push({
            id: "dropoff-shippop",
            name: "SHIPPOP DROP OFF",
          });
        }
        if (this.permission.dropoffVRich) {
          d.push({
            id: "dropoff-vrich",
            name: "VRICH DROP OFF",
          });
        }
        if (this.permission.dropoffPanPan) {
          d.push({
            id: "dropoff-panpan",
            name: "PANPAN WORLD DROP OFF",
          });
        }
        if (this.permission.dropoffEasyShip) {
          d.push({
            id: "dropoff-easyship",
            name: "EASYSHIP DROP OFF",
          });
        }
        if (this.permission.kerryDropoff) {
          d.push({
            id: "dropoff-kerry",
            name: "KEX Drop off",
          });
        }
        if (this.permission.lazadaDropoff) {
          d.push({
            id: "dropoff-lazada",
            name: "Lazada Drop off",
          });
        }
        if (this.permission.orangeDropoff) {
          d.push({
            id: "dropoff-orange",
            name: "Orange Drop off",
          });
        }
        if (this.permission.dropoffQuick) {
          d.push({
            id: "dropoff-quick",
            name: "QUICK EXPRESS DROP OFF",
          });
        }
        if (this.permission.lineBooking) {
          d.push({
            id: "line-booking",
            name: "LINE Booking",
          });
        }
        if (this.permission.flashDropoff) {
          d.push({
            id: "dropoff-flash",
            name: "FLASH Drop off",
          });
        }

        if (ls) {
          let result = [];
          let remain = [];

          Object.values(ls).forEach((value) => {
            if (!isNaN(value.id)) {
              const item = newVal.find((item) => item.id == value.id);
              if (item) {
                result.push(item);
              } else {
                remain.push(item);
              }
            } else {
              result.push(value);
            }
          });

          const list = [...result, ...remain];

          d.forEach((item) => {
            if (!list.find((i) => i.id == item.id)) {
              list.push(item);
            }
          });

          this.couriersCopy = list;
        } else {
          this.couriersCopy = [...d, ...newVal];
        }
      },
    },
  },
};
</script>

<style></style>
